import { Typography } from '@healthinal/ui';
import { TaskDto } from '../../../api/generated/model';

export function TaskCardTitle({ task }: { task: TaskDto }) {
  const noteTitle =
    task.notes ||
    task.journal?.notes ||
    task.labOrder?.notes ||
    task.appointment?.note ||
    'Keine Beschreibung des To Dos eingetragen';

  return (
    <Typography sx={{ whiteSpace: 'pre-line' }} level={'title-lg'}>
      {noteTitle}
    </Typography>
  );
}
